import classNames from 'classnames';
import { useIntl } from 'react-intl';

import styles from '../../../../styles/icons/logos/logo.module.scss';

import coorsliveLogoEn from '../../../../img/coorslive/coorslive_logo_en.png';
import coorsliveLogoFr from '../../../../img/coorslive/coorslive_logo_fr.png';

interface CoorsliveLogoProps {
    className?: string;
}

const CoorsliveLogo = ({ className = null }: CoorsliveLogoProps) => {
    const { locale } = useIntl();

    return (
        <img
            src={locale === 'fr' ? coorsliveLogoFr : coorsliveLogoEn}
            className={classNames([styles.container, { [className]: className !== null }])}
            alt="Coors Live"
        />
    );
};

export default CoorsliveLogo;
